// extracted by mini-css-extract-plugin
export var brand = "_1a-9";
export var button = "_1a-0";
export var chevron = "_1a-v";
export var chevronButton = "_1a-w";
export var content = "_1a-n";
export var danger = "_1a-g";
export var dangerOutlined = "_1a-h";
export var dark = "_1a-l";
export var darkTheme = "_1a-c";
export var extraSmall = "_1a-4";
export var fullWidth = "_1a-8";
export var ghost = "_1a-d";
export var gray = "_1a-t";
export var icon = "_1a-p";
export var iconButton = "_1a-s";
export var iconButtonBorder = "_1a-x";
export var iconButtonBorderDark = "_1a-y";
export var iconButtonBorderLight = "_1a-z";
export var iconLeft = "_1a-q";
export var iconRight = "_1a-r";
export var large = "_1a-1";
export var light = "_1a-m";
export var medium = "_1a-2";
export var micro = "_1a-5";
export var nano = "_1a-7";
export var outlined = "_1a-k";
export var pending = "_1a-a";
export var primary = "_1a-i";
export var shadow = "_1a-o";
export var small = "_1a-3";
export var solidLight = "_1a-e";
export var solidLightBrand = "_1a-f";
export var spinner = "_1a-u";
export var transparent = "_1a-j";
export var warning = "_1a-b";
export var wideNano = "_1a-6";